import { useRef, useState } from 'react'
import { Button } from './Button'
import { Menu, MenuItem } from './Menu'

export type ExportFormat = 'csv' | 'xlsx' | 'pdf'

export interface ExportMenuProps {
  /** Chiamata alla scelta del formato; l'errore lo gestisce il chiamante. */
  onExport: (format: ExportFormat) => void
  /** Formati offerti (default: tutti e tre). Excel e PDF di solito dietro il flag `export.excel`. */
  formats?: ExportFormat[]
  disabled?: boolean | undefined
  busy?: boolean | undefined
  title?: string | undefined
  size?: 'sm' | 'md' | undefined
  variant?: 'outlined' | 'text' | 'tonal' | undefined
}

const ITEMS: Record<ExportFormat, { label: string; icon: string }> = {
  csv: { label: 'CSV', icon: 'csv' },
  xlsx: { label: 'Excel', icon: 'table_view' },
  pdf: { label: 'PDF', icon: 'picture_as_pdf' },
}

/** C-14 (REQ-026-004): un solo pulsante "Esporta" con i formati CSV, Excel e PDF. */
export function ExportMenu({
  onExport, formats = ['csv', 'xlsx', 'pdf'], disabled, busy, title, size, variant = 'outlined',
}: ExportMenuProps) {
  const anchor = useRef<HTMLButtonElement>(null)
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button
        ref={anchor}
        variant={variant}
        size={size}
        icon="download"
        disabled={disabled || busy}
        title={title ?? 'Esporta in CSV, Excel o PDF'}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
      >
        {busy ? 'Preparazione…' : 'Esporta'}
      </Button>
      <Menu anchorRef={anchor} open={open} onClose={() => setOpen(false)} aria-label="Formato di esportazione">
        {formats.map(f => (
          <MenuItem key={f} icon={ITEMS[f].icon} onSelect={() => onExport(f)}>{ITEMS[f].label}</MenuItem>
        ))}
      </Menu>
    </>
  )
}
